<template>
    <span class="eip-vue" :class="{ 'eip-editing': isEditing }">
      <span class="eip-preview" v-show="!isEditing" @dblclick="enterEdit">{{ document }}</span>
  
      <a href="#" class="edit eip-edit" v-show="!isEditing" @click.prevent="enterEdit">
        <i class="icon icon-edit"></i>
      </a>
  
      <span class="eip-form" v-show="isEditing">
        <input type="text" class="field field-small" ref="field" :value="document" @input="updateDocument($event.target.value)" @keyup.enter="saveChanges" @keyup.esc="cancelEdit" />
        <input type="button" value="Save" class="button button-small bolded" :class="{ 'button-disabled': !document }" :disabled="!document" @click="saveChanges" />
        <input type="button" value="Cancel" class="button button-small" @click="cancelEdit" />
      </span>
    </span>
  </template>
  
  <script>
  export default {
    props: {
      document: {
        type: String,
        required: true,
        twoDay: true
      },
  
      keybindings: {
        type: Object,
        required: false,
        default: () => ({})
      },
  
      onSave: {
        type: Function,
        required: false,
        default: () => {}
      }
    },

    data() {
      return {
        isEditing: false,
        old: ''
      };
    },
  
    mounted() {
      // Bind the shortcuts
      Object.keys(this.keybindings).forEach((keybinding) => {
        this.$refs.field.addEventListener('keydown', (e) => {
          if (e.key === keybinding) {
            e.preventDefault();
            this.keybindings[keybinding]();
          }
        });
      });
    },
  
    beforeUnmount() {
      // Clean any attached handlers
      Object.keys(this.keybindings).forEach((keybinding) => {
        this.$refs.field.removeEventListener('keydown', this.keybindings[keybinding]);
      });
    },
  
    methods: {
      enterEdit() {
        // Enable edit mode
        this.isEditing = true;
  
        // Cache the current value of the model as reference
        // that will be used to restore the model when the edit mode is cancelled
        this.old = this.document;
  
        // Select the text entered in the field
        this.$nextTick(() => this.select());
      },
  
      leaveEdit() {
        // Disable edit mode
        this.isEditing = false;
      },
  
      cancelEdit() {
        // Return to the preview mode
        this.leaveEdit();
  
        // Restore the initial value of the model
        this.$emit('update', this.old);
      },
  
      select() {
        // Select the text in field
        this.$refs.field.select();
      },
  
      updateDocument(value) {
        // Update the document prop
        this.$emit('update', value);
      },
  
      saveChanges() {
        // Call the provided callback
        this.onSave();
      }
    }
  };
  </script>
  